import { type FC } from "react";
import {
  Card,
  Grid,
  Typography,
  CardContent,
  CardActionArea,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { Link } from "react-router-dom";

export interface MetricCardMetric {
  label: string;
  value: string | number;
  trend?: number;
  xs: number;
}

export interface MetricCardData {
  primary?: MetricCardMetric;
  secondary?: MetricCardMetric;
  to?: string;
  xs?: number;
  sm?: number;
  md?: number;
}

const Metric: FC<{ metric: MetricCardMetric }> = ({ metric }) => {
  const trend = metric.trend ?? 0;
  const trendColor = trend > 0 ? "success.main" : "error.main";
  const TrendIcon = trend > 0 ? TrendingUpIcon : TrendingDownIcon;

  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <Typography variant="subtitle2" color="text.secondary">
          {metric.label}
        </Typography>
      </Grid>
      <Grid size={12}>
        <Typography variant="h5" color="text.primary" sx={{ fontWeight: 600 }}>
          {metric.value}
        </Typography>
      </Grid>
      {!!trend && (
        <Grid size={12}>
          <Typography
            color={trendColor}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <TrendIcon sx={{ mr: 1 }} /> {trend}%
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export const MetricCard: FC<{ metric: MetricCardData }> = ({ metric }) => {
  const content = (
    <CardContent sx={{ p: 3 }}>
      <Grid container spacing={1}>
        {metric.primary && (
          <Grid size={metric.primary.xs}>
            <Metric metric={metric.primary} />
          </Grid>
        )}
        {metric.secondary && (
          <Grid size={metric.secondary.xs}>
            <Metric metric={metric.secondary} />
          </Grid>
        )}
      </Grid>
    </CardContent>
  );

  return (
    <Card elevation={0} sx={{ width: "100%" }}>
      {metric.to ? (
        <CardActionArea component={Link} to={metric.to}>
          {content}
        </CardActionArea>
      ) : (
        <CardActionArea disabled>{content}</CardActionArea>
      )}
    </Card>
  );
};
